import Button from '@carvana/ds-button';
import { Trash2 } from 'lucide-react';
import { clearAllFeatureCookies } from '~/utilities/featureBranch';

export default function ClearAllButton() {
  return (
    <Button
      className="pointer-events-auto mr-20 h-28 shrink-0 self-end t-label-xs"
      onClick={clearAllFeatureCookies}
      data-analytics-id="Clear all feature branches"
      data-testid="clear-all-feature-branches"
      title="Clear all feature branches"
      size="sm"
      variant="destructive"
      utility
    >
      <Trash2 size={12} /> Clear All
    </Button>
  );
}
